import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "tableHead",
  class: "table-head table-head-rui"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", null, "降り始め", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "降り終わり", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("10分間最大雨量")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("(mm)")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("1時間最大雨量")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("(mm)")
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "総雨量(mm)", -1)

import { useGlobalStore } from '@/stores/globalStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _hoisted_3,
      (!_unref(globalStore).isIchinomiya)
        ? (_openBlock(), _createElementBlock("td", _hoisted_4, _hoisted_8))
        : _createCommentVNode("", true),
      (!_unref(globalStore).isIchinomiya)
        ? (_openBlock(), _createElementBlock("td", _hoisted_9, "起時"))
        : _createCommentVNode("", true),
      (!_unref(globalStore).isIchinomiya)
        ? (_openBlock(), _createElementBlock("td", _hoisted_10, _hoisted_14))
        : _createCommentVNode("", true),
      (!_unref(globalStore).isIchinomiya)
        ? (_openBlock(), _createElementBlock("td", _hoisted_15, "起時"))
        : _createCommentVNode("", true),
      _hoisted_16
    ])
  ]))
}
}

})